// Memorial entry for Ran Gvili
import ranGviliPortrait from '../../../images/ran-gvili.jpg';

export const ranGviliMemorial = {
  id: 44,
  name: 'St.-Sgt.-Maj. Ran Gvili',
  images: {
    portrait: ranGviliPortrait
  },
  info: `
"What do you think? Do you think that my friends will fight alone?" - Ran to his father before leaving

# Staff Sergeant Major Ran Gvili

![Ran Gvili](${ranGviliPortrait})
*Staff Sergeant Major Ran Gvili, 24, Protector of Alumim*

## The First to Go, The Last to Return

Ran Gvili was home in Meitar on medical leave, recovering from a broken shoulder, scheduled for surgery in two days. When news of the Hamas attack reached him, he put on his uniform.

His father asked where he was going. Ran replied: "What do you think? Do you think that my friends will fight alone?"

At 24, Ran served in Yasam, the elite police counter-terrorism unit. He had overcome a severe leg injury during Golani Brigade training through "an insane amount of physical therapy." He loved motorcycles, played guitar (especially Santana), built furniture with his own hands.

## The Hero of October 7

Ran traveled to Beersheba, then joined six fighters heading toward the border. At a gas station, he encountered survivors from the Nova festival and helped rescue 100-150 people.

He insisted on returning to Kibbutz Alumim, where a fierce battle was unfolding. At the junction, vehicles carrying dozens of terrorists opened fire. Ran was shot in the leg and arm.

Wounded, he hid in vegetation. He gave his water pack to a more severely wounded comrade. He used his phone to send enemy coordinates to his team. His last text at 10:50 AM: "I've been shot in the leg."

Investigation revealed Ran "fought alone with great courage, and did not give up until he ran out of ammunition." Fourteen terrorist bodies were recovered where he made his last stand.

## 843 Days

He was the last hostage held in Gaza. On January 26, 2026, his remains were recovered in Operation Brave Heart. He was found still wearing his police uniform.

His mother Talik: "The first to go out, the last to return. Our hero."

His father Itzik: "All of Israel knows your story. Everyone holds you close in their hearts - you are the son of all."

His sister Shira: "I never imagined it would take 843 days... I really did everything to bring you back."

With his return, for the first time since 2014, no Israeli hostages remained in Gaza.

*Rani, Protector of Alumim. May his memory be a blessing.*

[Read more](https://www.timesofisrael.com/missing-police-officer-ran-gvili-left-hospital-to-go-fight/)
`
};
